// resets the date object to non-relative but maintains selected date
const removeRelativeDateValues = (dateObj) => {
  return Object.assign({}, dateObj, {
    isRelative: false,
    operator: null,
    specificTime: '',
    specificTimeToggle: false,
    anchor: null,
    occurrence: {},
    anchorDate: null,
    months: 0,
    days: 0,
    hours: 0,
    weeks: 0,
    minutes: 0,
  });
};

export const removeRalativeDateValuesForPlAndPc = (dateObj) => {
  return Object.assign({}, dateObj, {
    isRelative: false,
    operator: null,
    dateTime: '',
    specificTime: '',
    specificTimeToggle: false,
    anchor: null,
    occurrence: {},
    anchorDate: null,
    months: 0,
    days: 0,
    hours: 0,
    weeks: 0,
    minutes: 0,
  });
};
export default removeRelativeDateValues;



// WEBPACK FOOTER //
// ./src/common/lib/RemoveRelativeDate.js